import secureLocalStorage from "react-secure-storage";
import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";

export const USERDATA = "riskwell/fetch/USERDATA";
export const USERFETCHFAIL = "riskwell/fetch/USERFETCHFAIL";
export const LOGGEDINLOADER = "riskwell/fetch/LOGGEDINLOADER";
export const USERDATAFAILURE = "riskwell/fetch/USERDATAFAILURE";

export const UserData = (Data) => {
  return {
    type: USERDATA,
    payload: Data,
  };
};

export const UserDataFailure = (err) => {
  return {
    type: USERDATAFAILURE,
    payload: err,
  };
};

export const UserFetchFail = (error) => {
  return {
    type: USERFETCHFAIL,
    payload: error,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const FetchUserData = (TenantKey) => async (dispatch) => {
  try {
    debugger; 
    dispatch(loggedInLoader(true));
    let result = await Api.getuserAddedByTenant(TenantKey);

    dispatch(loggedInLoader(false));
    if (result.status === 200 && result.message === "Success") {
      // toastr.success(result && result.message);
      let email = secureLocalStorage.getItem("setEmail");
      let userList=result.tenantUsers.filter((item)=>item.emailAddress!=email);
      dispatch(UserData(userList));
    }
    //  else if (result.statusText === "Unauthorized") {
    //   dispatch(UserDataFailure(result.statusText));
    //   toastr.error(result.statusText);
    // }
     else {
      // toastr.error(result.message);
      dispatch(UserFetchFail(result.message));
      dispatch(UserData([]));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    dispatch(UserFetchFail(error));
  }
};
export const FetchUserGridData = (TenantKey) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.getuserAddedByTenant(TenantKey);

    dispatch(loggedInLoader(false));
    if (result.status === 200 && result.message === "Success") {
      // let email = secureLocalStorage.getItem("setEmail");
      // let userList=result.tenantUsers.filter((item)=>item.emailAddress!=email && item.isSuperAdmin !=true);
      dispatch(UserData(result.tenantUsers));
    } 
    // else if (result.statusText === "Unauthorized") {
    //   dispatch(UserDataFailure(result.statusText));
    //   toastr.error(result.statusText);
    // }
     else {
      // toastr.error(result.message);
      dispatch(UserFetchFail(result.message));
      dispatch(UserData([]));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    dispatch(UserFetchFail(error));
  }
};
